<script>
import imgEmptyIcon from '@/components/countly/images/icons/empty-view-icon.svg';
import countlyVue from '../../compat/vue-core';
import i18n from '../../../../i18n';

export default countlyVue.mixins.BaseContent.extend({
  props: {
    image: { default: imgEmptyIcon, type: String },
    title: { default: i18n.tc('common.emtpy-view-title'), type: String },
    subTitle: { default: i18n.tc('common.emtpy-view-subtitle'), type: String },
    height: { default: 0, type: Number },
    classes: {
      type: Object,
      default() {
        return {
          'bu-py-6': true,
        };
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    topStyle() {
      if (this.height) {
        return { height: `${this.height}px` };
      }
      return '';
    },
  },
});
</script>
<template>
  <div
    :style="topStyle"
    :class="['bu-is-flex bu-is-flex-direction-column bu-is-align-items-center bu-is-justify-content-center', classes]"
    style="height: 100%;opacity: 0.6"
  >
    <slot name="icon">
      <div>
        <img :src="image">
      </div>
    </slot>
    <div class="bu-mt-2">
      <slot name="title">
        <h4 class="color-cool-gray-100 bu-has-text-centered">
          {{ title }}
        </h4>
      </slot>
      <slot name="subTitle">
        <div class="bu-mt-1 text-small color-cool-gray-50 bu-has-text-centered">
          {{ subTitle }}
        </div>
      </slot>
    </div>
  </div>
</template>
